import httpService from '@/modules/common/services/httpService';
import gatewayService from '@/modules/common/services/gatewayService';

const baseRoute = '/business/payments/v1/invoices';
const v2Route = '/v2/invoices';

const fetchInvoice = async (invoiceUid) => httpService.get(`${v2Route}/${invoiceUid}?full=true`)
  .then((res) => res.data);

const cancelInvoice = async (invoiceUid, payload) => httpService.put(`${baseRoute}/${invoiceUid}/cancel`, payload)
  .then((res) => res.data);

const createCreditNote = async (payload) => gatewayService.post('/v3/payments/credit_notes', payload)
  .then((res) => res.data);

export default {
  fetchInvoice,
  cancelInvoice,
  createCreditNote,
};
